import type { CurvaDocument } from "@/document/model/document";
import { ApplyScriptDocumentCommand } from "@/commands/scriptCommands";
import type { EditorCommandHost } from "@/editor/commands/editorCommandHost";

export function applyScriptDocumentPages(
  host: EditorCommandHost,
  runId: string,
  pages: CurvaDocument["pages"],
  frameId?: string,
): void {
  const context = host.commandContext();
  host.history.execute(new ApplyScriptDocumentCommand(runId, pages, frameId), context);
  host.commit(context.document, "Applied script changes");
}
